/*
 * Copyright (c) 2022. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
export var ExecutorConfigType;
(function (ExecutorConfigType) {
    ExecutorConfigType["local"] = "local";
    ExecutorConfigType["localdask"] = "localdask";
    ExecutorConfigType["dask"] = "dask";
    ExecutorConfigType["daskStatic"] = "dask-static";
})(ExecutorConfigType || (ExecutorConfigType = {}));
export const executorConfigSchema = z.object({
    type: z.enum(ExecutorConfigType),
    cpu_request: z.string().optional().nullable(),
    mem_request: z.string().optional().nullable(),
    threads_per_worker: z.number().positive().optional().nullable(),
    min_workers: z.number().positive().optional().nullable(),
    max_workers: z.number().positive().optional().nullable(),
    manually_trim_memory: z.boolean().optional().nullable(),
    scheduler: z.enum(['threads', 'processes']).optional().nullable(),
    num_workers: z.number().positive().optional().nullable(),
    scheduler_ip: z.string().optional().nullable(),
});
//# sourceMappingURL=executor.js.map